import { IconProps } from '../types';
import classnames from 'classnames';

/**
 * Dankort acceptance mark — the red pill with the white "DK" letterforms.
 *
 * Artwork: datatrans/payment-logos `assets/cards/dankort.svg` (fetched 2026-09-15), CC BY-SA 4.0 —
 * attribution: Datatrans AG. Unmodified apart from dropping the pack's white card backdrop and
 * cropping the 120×80 canvas to the pill. Shown to indicate that the card is accepted at checkout,
 * which is what the scheme's acceptance-mark rules provide the artwork for.
 */
export default function DankortIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-4', className)} viewBox="13 11 94 58" fill="none" style={style}>
      <path
        d="M41.723 12.8136C26.755 12.8136 14.5771 25.0088 14.5771 39.9987C14.5771 54.99 26.755 67.1864 41.723 67.1864L78.2807 67.1864C93.2468 67.1864 105.423 54.99 105.423 39.9987C105.423 25.0088 93.2468 12.8136 78.2807 12.8136L41.723 12.8136Z"
        fill="white"
      />
      <path
        d="M76.4797 54.038L66.3749 41.2476C64.5057 49.9683 58.3898 54.0365 46.9246 54.0365H24.0752C28.2088 59.2389 34.5831 62.5807 41.723 62.5807L78.2809 62.5807C85.4183 62.5807 91.7912 59.2403 95.925 54.038H76.4797Z"
        fill="#E41D27"
      />
      <path
        d="M84.6714 38.3387L96.828 52.8191C99.3457 49.1748 100.824 44.7573 100.824 39.9989C100.824 34.9767 99.177 30.3321 96.3971 26.5779L84.6714 38.3387Z"
        fill="#E41D27"
      />
      <path
        d="M35.2658 35.0133L32.0239 43.9409H45.1036C48.9703 43.9409 50.1402 42.3375 51.0055 39.2509C51.8619 36.1979 49.7109 35.0133 47.0684 35.0133H35.2658Z"
        fill="#E41D27"
      />
      <path
        d="M50.2234 25.3556C59.3017 25.3556 66.142 27.6691 66.8461 35.3301L76.4003 25.3545H95.4249C91.2864 20.5028 85.1362 17.4207 78.2808 17.4207L41.7231 17.4207C34.8652 17.4207 28.714 20.5028 24.5752 25.3556L50.2234 25.3556Z"
        fill="#E41D27"
      />
    </svg>
  );
}
